import { Component, Input, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { Observable } from 'rxjs';

interface ProgressStep {
  color: string;
  message: string;
}

@Component({
  selector: 'app-upload-progress',
  standalone: true,
  imports: [CommonModule, NzProgressModule],
  encapsulation: ViewEncapsulation.None,
  template: `
    <div
      class="progress-container"
      *ngIf="
        (progress$ | async) !== null &&
        (progress$ | async)! > 0 &&
        (progress$ | async)! < 100
      ">
      <nz-progress
        [nzPercent]="(progress$ | async) ?? 0"
        [nzFormat]="percentTemplate"
        [nzShowInfo]="true"
        [nzStrokeColor]="getStrokeColorConfig((progress$ | async) ?? 0)"
        nzStatus="active">
      </nz-progress>
      <div class="message-text">
        {{ getProgressMessage((progress$ | async) ?? 0) }}
      </div>
    </div>
    <ng-template #percentTemplate let-percent>{{ percent }}%</ng-template>
  `,
})
export class UploadProgressComponent {
  @Input() progress$!: Observable<number>;

  private readonly progressSteps: ProgressStep[] = [
    { color: '#9bdfc0', message: 'Getting your file ready...' },
    { color: '#6fd0a3', message: 'Preparing data...' },
    { color: '#43c187', message: 'Validating entries...' },
    { color: '#17b26a', message: 'Processing your request...' },
    { color: '#128e55', message: 'Just a few moments more...' },
  ];

  getStrokeColorConfig(percent: number): Record<string, string> {
    const currentStepIndex = Math.floor(percent / 20);
    const nextStepIndex = Math.min(
      currentStepIndex + 1,
      this.progressSteps.length - 1
    );

    return {
      '0%': this.progressSteps[currentStepIndex].color,
      '100%': this.progressSteps[nextStepIndex].color,
    };
  }

  getProgressMessage(percent: number): string {
    const stepIndex = Math.floor(percent / 20);
    return (
      this.progressSteps[stepIndex]?.message || this.progressSteps[0].message
    );
  }
}
